import { useState } from "react";
import { ClickableDate } from "./ClickableDate";
import { localDateStr } from "../lib/date";
import { useIsMobile } from "../lib/useIsMobile";

export function ManualJobModal({ clients, preselectedClient, onClose, onSave }) {
  const isMobile = useIsMobile();
  const [form, setForm] = useState({
    client_id:   preselectedClient?.id   ?? "",
    client_name: preselectedClient?.name ?? "",
    date:        localDateStr(),
    time:        "",
    notes:       "",
    cost:        "",
  });
  const [saving, setSaving] = useState(false);

  const selectedClient = clients.find(c=>c.id===form.client_id);

  function handleClientChange(e) {
    const c = clients.find(c=>c.id===e.target.value);
    setForm(f=>({...f, client_id:e.target.value, client_name:c?.name||""}));
  }

  async function handleSave() {
    if (!form.client_id) { alert("Please select a client"); return; }
    if (!form.date)      { alert("Please select a date"); return; }
    setSaving(true);
    await onSave({
      client_id:   form.client_id,
      client_name: form.client_name,
      date:        form.date,
      time:        form.time||null,
      notes:       form.notes||null,
      cost:        Number(form.cost)||0,
      status:      "scheduled",
    });
    setSaving(false);
  }

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:480}}>
        <div className="modal-header">
          <h3>⭐ Schedule Manual Job</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div style={{background:"#f0f4ff",border:"1px solid #c7d2fe",borderRadius:6,padding:"8px 12px",marginBottom:14,fontSize:12,color:"#42526e"}}>
            This job will appear in Today's Route on the selected date alongside regular jobs. It does <strong>not</strong> affect the client's subscription.
          </div>

          <div className="form-grid">
            <div className="form-group full">
              <label>Client *</label>
              {clients.length === 0 ? (
                <div style={{fontSize:13,color:"#bf2600",background:"#ffebe6",border:"1px solid #ffbdad",borderRadius:6,padding:"10px 12px"}}>
                  No active clients to schedule. Add a client — or reactivate a paused one — first, then come back to create a manual job.
                </div>
              ) : (
                <select value={form.client_id} onChange={handleClientChange} disabled={!!preselectedClient}>
                  <option value="">— Select a client —</option>
                  {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              )}
            </div>
            <div className="form-group">
              <label>Date *</label>
              {/* Phone: the form-grid is one column, so the inline-flex chip fills its row like the time input beside it. */}
              <ClickableDate value={form.date} onChange={v=>setForm(f=>({...f,date:v}))} min={localDateStr()} width={isMobile?"100%":undefined} style={isMobile?{minHeight:44,boxSizing:"border-box"}:undefined}/>
            </div>
            <div className="form-group">
              <label>Time (optional)</label>
              <input type="time" value={form.time} onChange={e=>setForm(f=>({...f,time:e.target.value}))}/>
            </div>
            <div className="form-group full">
              <label>Notes / Job Description</label>
              <textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} placeholder="e.g. Extra cleanup after storm, back yard only..."/>
            </div>
            <div className="form-group full">
              <label>Cost ($) — leave blank for free</label>
              <input type="number" step="0.01" min="0" value={form.cost} onChange={e=>setForm(f=>({...f,cost:e.target.value}))} placeholder="0.00"/>
              {Number(form.cost)>0 && selectedClient?.stripe_pm_last4 && (
                <div style={{fontSize:11,color:"#006644",background:"#e3fcef",padding:"3px 8px",borderRadius:4,marginTop:4}}>
                  💳 Will charge ${Number(form.cost).toFixed(2)} to card on file (···· {selectedClient.stripe_pm_last4}) now, when you schedule this job
                </div>
              )}
              {Number(form.cost)>0 && selectedClient && !selectedClient.stripe_pm_last4 && (
                <div style={{fontSize:11,color:"#bf2600",background:"#ffebe6",padding:"3px 8px",borderRadius:4,marginTop:4}}>
                  ⚠️ No card on file — job will be scheduled but you'll need to collect payment separately
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="modal-footer" style={isMobile?{alignItems:"center"}:undefined}>
          {/* Phone: a 0.6-opacity gold button does not read as disabled — say what is missing. */}
          {isMobile && !saving && (!form.client_id || !form.date) && clients.length > 0 && (
            <span style={{marginRight:"auto",fontSize:12.5,color:"var(--text2)",flex:"1 1 100%"}}>
              {!form.client_id ? "Pick a client to continue" : "Pick a date to continue"}
            </span>
          )}
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-gold" onClick={handleSave} disabled={saving||!form.client_id||!form.date}>
            {saving?"Saving...":"Schedule Job"}
          </button>
        </div>
      </div>
    </div>
  );
}
